<template>
  <div>
    <div class="results-page">
      <div class="bg"></div>
      <div class="content">
        <img
          class="results"
          src="./../../assets/microscope/results.png"
          alt=""
        />
        <div class="topTitle">恭喜您已完成全部诊疗思路考核!</div>
        <div class="pic">{{ answerData.score }}</div>
        <div class="pictxt">您的总成绩</div>
        <div class="pictxtall">(满分100分)</div>
        <div class="explain">所有诊疗思路</div>
        <div class="explain">考核题目答案即时查看！</div>
        <div class="detail" @click="handleGoAnswer">
          <img class="detailIcon" src="./../../assets/treat/case.png" alt="" />
          <div class="text">点此查看您的病历记录</div>
        </div>
      </div>
      <div class="footer">
        <div @click="handleBtn" class="btn">确认</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPetScore } from "@/api/system/exam";
export default {
  data() {
    return {
      answerData: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.handleGoHome, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.handleGoHome, false);
  },
  methods: {
    //获取总成绩
    init() {
      getPetScore().then((res) => {
        if (res.data.code === 0) {
          this.answerData = res.data.data;
        }
      });
    },
    // 回首页
    handleGoHome() {
      this.$router.replace({
        path: "/index/home2026",
        query: { isLogin: false },
      });
    },
    //
    handleBtn() {
      this.$router.push("/treat/assemble");
    },

    //
    handleGoAnswer() {
      this.$router.push({
        path: "/treat/medicalrecord",
        query: { num: 7 },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.results-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/cbbj.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 90px;
  }
  .content {
    width: 653px;
    // height: 1239px;
    padding-bottom: 80px;
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    margin: 0 auto;
    margin-bottom: 150px;
    padding-top: 98px;
    .results {
      display: block;
      width: 109px;
      margin: 0 auto;
    }
    .topTitle {
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 46px;
    }
    .pic {
      width: 375px;
      height: 375px;
      background: rgba(0, 173, 163, 0.7);
      border-radius: 50%;
      line-height: 375px;
      text-align: center;
      font-size: 157px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
      margin-top: 50px;
    }
    .pictxt {
      margin-top: 28px;
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    .pictxtall {
      margin-bottom: 60px;
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    .explain {
      font-size: 30px;
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .detail {
      width: 552px;
      height: 124px;
      line-height: 124px;
      background: #04397d;
      opacity: 0.75;
      border-radius: 62px;
      font-size: 35px;
      text-align: end;
      margin: 80px 0px 0px 49px;
      position: relative;
      .text {
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        margin-right: 58px;
      }
      .detailIcon {
        width: 127px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .flex {
      display: flex;
      margin: 0 32px;
      .left,
      .right {
        .top {
          font-size: 25px;
          font-family: HarmonyOS Sans SC;
          font-weight: bold;
          color: #ab3b91;
        }
        .bottom {
          font-size: 25px;
          font-family: HarmonyOS Sans SC;
          font-weight: bold;
          color: #4c4c4c;
        }
      }
      .right {
        margin-left: auto;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 570px;
    height: 143px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 40px 90px 0 90px;
    display: flex;
    .btn {
      width: 310px;
      height: 88px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>
